module.exports = __webpack_public_path__ + "static/media/mountainsBackground.bfc96fe6.png";